import { render } from "./thana-list-modal.vue?vue&type=template&id=6b7beba3"
import script from "./thana-list-modal.vue?vue&type=script&lang=js"
export * from "./thana-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__